/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var GLOBAL_FILTER_CLASS = '*';
    MoyaComponents.register('inna.filter', function (el) {
        var resultsContainer = el.dataset.filterContainer ? document.querySelector(el.dataset.filterContainer) : null;
        var toggles = Array.from(el.querySelectorAll('[data-filter-class]')).map(function (el) {
            return FilterToggle.create(el);
        });
        if (!toggles) {
            console.debug('Missing filter toggles');
        }
        if (!resultsContainer) {
            console.debug('Missing filter container');
        }
        var results = Array.from(resultsContainer.children).map(function (result) {
            return FilterResult.create(result);
        });
        if (!results) {
            console.debug('Missing filter results');
        }
        var config = {
            el: el,
            resultsContainer: resultsContainer,
            results: results,
            toggles: toggles,
            transitionName: el.dataset.transition,
        };
        Filter.create(config).run();
    });
    var Filter = /** @class */ (function () {
        function Filter(config) {
            this.el = config.el;
            this.resultsContainer = config.resultsContainer;
            this.results = config.results;
            this.toggles = config.toggles;
            this.transitionName = config.transitionName;
        }
        Filter.create = function (config) {
            return new Filter(config);
        };
        Filter.prototype.run = function () {
            this.addInitialClasses();
            this.delegateEvents();
            var toggleFromQueryParam = this.getToggleFromQueryParam();
            if (toggleFromQueryParam) {
                this.clickToggle(toggleFromQueryParam);
                return;
            }
            var globalToggle = this.getGlobalFilterToggle();
            if (globalToggle) {
                globalToggle.markActive();
            }
        };
        Filter.prototype.addInitialClasses = function () {
            this.resultsContainer.classList.add('inna-filter-container');
            if (this.transitionName) {
                this.resultsContainer.classList.add(this.transitionName);
            }
        };
        Filter.prototype.delegateEvents = function () {
            var _this = this;
            util.delegate(this.el, 'click', '[data-filter-class]', function (e) {
                var filterToggle = _this.getToggleByFilterClass(e.delegateTarget.dataset.filterClass);
                if (!filterToggle) {
                    return;
                }
                _this.clickToggle(filterToggle);
            });
        };
        Filter.prototype.clickToggle = function (toggle) {
            var globalToggle = this.getGlobalFilterToggle();
            if (toggle.isActive() && globalToggle) {
                // "de-select"
                this.clickToggle(globalToggle);
                return;
            }
            this.toggles.forEach(function (toggle) { return toggle.unmarkActive(); });
            toggle.markActive();
            toggle.updateQuery();
            this.filterByClassName(toggle.getFilterClass());
        };
        Filter.prototype.filterByClassName = function (className) {
            var _this = this;
            this.resultsContainer.classList.add('isFiltering');
            setTimeout(function () {
                _this.results.forEach(function (result) {
                    if (result.matches(className)) {
                        result.show();
                    }
                    else {
                        result.hide();
                    }
                });
                _this.resultsContainer.classList.remove('isFiltering');
            }, 200);
        };
        Filter.prototype.getToggleByFilterClass = function (filterClass) {
            return this.toggles.filter(function (toggle) {
                return toggle.getFilterClass() === filterClass;
            }).shift();
        };
        Filter.prototype.getGlobalFilterToggle = function () {
            return this.getToggleByFilterClass(GLOBAL_FILTER_CLASS);
        };
        Filter.prototype.getActiveFilterToggle = function () {
            return this.toggles.filter(function (toggle) {
                return toggle.isActive();
            }).shift();
        };
        Filter.prototype.getToggleFromQueryParam = function () {
            var urlParams = new URLSearchParams(window.location.search);
            var filterClass = urlParams.get('filter');
            if (!filterClass) {
                return null;
            }
            return this.getToggleByFilterClass(filterClass);
        };
        return Filter;
    }());
    var FilterToggle = /** @class */ (function () {
        function FilterToggle(el) {
            this.el = el;
            this.filterClass = el.dataset.filterClass;
        }
        FilterToggle.create = function (el) {
            return new FilterToggle(el);
        };
        FilterToggle.prototype.getFilterClass = function () {
            return this.filterClass;
        };
        FilterToggle.prototype.isActive = function () {
            return this.active;
        };
        FilterToggle.prototype.isGlobal = function () {
            return this.filterClass === GLOBAL_FILTER_CLASS;
        };
        FilterToggle.prototype.markActive = function () {
            this.el.classList.add('active');
            this.active = true;
        };
        FilterToggle.prototype.unmarkActive = function () {
            this.el.classList.remove('active');
            this.active = false;
        };
        FilterToggle.prototype.updateQuery = function () {
            if (this.isGlobal()) {
                window.history.replaceState('', '', window.location.pathname);
                return;
            }
            var filterQueryParam = '?filter=' + this.filterClass;
            window.history.replaceState('', '', filterQueryParam);
        };
        return FilterToggle;
    }());
    var FilterResult = /** @class */ (function () {
        function FilterResult(el) {
            this.el = el;
        }
        FilterResult.create = function (el) {
            return new FilterResult(el);
        };
        FilterResult.prototype.show = function () {
            this.el.style.removeProperty('display');
        };
        FilterResult.prototype.hide = function () {
            this.el.style.display = 'none';
        };
        FilterResult.prototype.matches = function (className) {
            if (className === GLOBAL_FILTER_CLASS) {
                return true;
            }
            return this.el.classList.contains(className);
        };
        return FilterResult;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
